<div *ngIf="statusCode === statusTypes.failsafe" class="failsafe">
    {{ 'device.status.failsafe' | translate }}
    <span *ngIf="reason">
        {{'#' + reason}}
    </span>
</div>

<div *ngIf="statusCode === statusTypes.busy && reason === busyReason.WAITING_FOR_MATERIAL_SETUP" class="waitingForMaterialSetup">
    {{ 'device.status.material-setup' | translate }}
</div>

<div *ngIf="statusCode === statusTypes.printing && reason === printingReason.COMPLETED" class="complete">
    {{ 'device.status.completed' | translate }}
</div>

<div *ngIf="statusCode === statusTypes.printing && reason === printingReason.STOPPED" class="complete__by-reason">
    {{ 'device.status.complete-reason.stopped' | translate }}
</div>

<div *ngIf="statusCode === statusTypes.printing && reason === printingReason.PAUSED_NO_MATERIAL" class="complete__by-reason">
    {{ 'device.status.complete-reason.stopped' | translate }}
</div>

<div *ngIf="statusCode === statusTypes.printing && reason === printingReason.PAUSED" class="pause">
    {{ 'device.status.paused' | translate }}
</div>

<div *ngIf="statusCode === statusTypes.printing && reason === printingReason.PREPARING_FOR_PRINT" class="preparingForPrint">
    {{ 'device.status.preparing-for-print' | translate }}
</div>

<div *ngIf="statusCode === statusTypes.printing && reason === printingReason.NO_REASON" class="printing">
    {{ 'device.status.printing' | translate }}
</div>

<div *ngIf="statusCode === statusTypes.busy && reason === busyReason.NO_REASON" class="busy">
    {{ 'device.status.busy' | translate }}
</div>

<div *ngIf="statusCode === statusTypes.idle" class="readyToPrint">
    {{ 'device.status.ready-to-print' | translate }}
</div>

<div *ngIf="statusCode === statusTypes.offline" class="offline">
    {{ 'device.status.offline' | translate }}
</div>

<div *ngIf="statusCode === statusTypes.printing && reason === printingReason.HEATING" class="preparingForPrint">
    {{ 'device.status.heating' | translate }}
    <span *ngIf="heatingProgress">
        ({{heatingProgress}}%)
    </span>
</div>

<div *ngIf="statusCode === statusTypes.printing && reason === printingReason.HOMING" class="preparingForPrint">
    {{ 'device.status.homing' | translate }}
</div>

<div *ngIf="statusCode === statusTypes.printing && reason === printingReason.PARSING" class="preparingForPrint">
    {{ 'device.status.parsing' | translate }}
    <span *ngIf="heatingProgress">
        ({{heatingProgress}}%)
    </span>
</div>

<div *ngIf="statusCode === statusTypes.busy && reason === busyReason.WAITING_FOR_USER_ACTION" class="waitingForUserAction">
    {{ 'device.status.waiting-for-user-action' | translate }}
</div>

<div *ngIf="statusCode === statusTypes.unavailable" class="unavailable">
    {{ 'device.status.unavailable' | translate }}
</div>

<div *ngIf="statusCode === statusTypes.blackout" class="blackout">
    {{ 'device.status.blackout' | translate }}
</div>

<div *ngIf="statusCode === statusTypes.busy && reason === busyReason.INITIALIZING" class="initializing">
    {{ 'device.status.initializing' | translate }}
</div>

<div *ngIf="statusCode === statusTypes.unknown" class="unknown">
    {{ 'device.status.unknown' | translate }}
</div>
